import { TreatmentDetailResponseDto } from "@/data/dto/patient-treatement-detail-list/treatment-detail-reponse-dto";
import { TreatmentDetailEntity } from "@/domain/entity/treatment/treatment-info-entity";
import { formatLocalToYyyyMmDd } from "@/utils/date-util";
import { getProgressType, ProgressType } from "@/utils/enum/progress-type";
import { getTreatmentState, TreatmentState } from "@/utils/enum/treatment-state-enum";
import { TreatmentActivityDetailInfoMapper } from "./treatment-activity-detail-info-mapper";
import { assertTreatmentDetailResponseDto } from "@/utils/validation";

export class TreatmentDetailResponseMapper {
  static toEntity(dto: TreatmentDetailResponseDto): TreatmentDetailEntity {
    // AST 기반 타입 검증
    assertTreatmentDetailResponseDto(dto);
    // console.log("[TreatmentDetailInfoMapper] :: toEntity :: ", dto);
    const progressType = getProgressType(dto.treatmentInfo.state);

    let isAvailableStopTreatment = false;
    switch (progressType) {
      case ProgressType.NOT_STARTED:
      case ProgressType.IN_PROGRESS:
        isAvailableStopTreatment = true;
        break;
      default:
        isAvailableStopTreatment = false;
        break;
    }

    const playedTime = parseInt(dto.treatmentInfo.actuallyPlayTime.toString());
    console.log(
      "[TreatmentDetailInfoMapper] :: toEntity :: dto.treatmentInfo.actuallyPlayTime",
      dto.treatmentInfo.actuallyPlayTime
    );
    console.log("[TreatmentDetailInfoMapper] :: toEntity :: playedTime", playedTime);

    const startDate = new Date(dto.treatmentInfo.startDate);
    const endDate = new Date(dto.treatmentInfo.endDate);
    // 진행중인 경우 오늘 날짜를 종료 날짜로 사용
    // 종료 날짜는 plan에서 일자별 빈 값을 채우는 용도로 사용됨
    // ex) 상태가 진행중이 아니라면 특정 날짜에 멈춘 것(취소 or 완료)이므로 plan 날짜를 오늘날자까지 채워줄 필요가 없음
    //     상태가 진행중인 경우 오늘 날짜까지 plan 데이터를 채워야함 (오늘 환자가 수행 안햇을 수 있음)
    const planEndDate =
      dto.treatmentInfo.state === TreatmentState.inProgress ? new Date() : endDate;

    const adherence =
      dto.treatmentInfo.actuallyPlayTime > 0 && dto.treatmentInfo.recommendedTotalPlayTime > 0
        ? Number(
            (
              (dto.treatmentInfo.actuallyPlayTime / dto.treatmentInfo.recommendedTotalPlayTime) *
              100
            ).toFixed(1)
          )
        : 0;

    return {
      uuid: dto.treatmentInfo.treatmentInfoUuid,
      stepInfo: {
        step: dto.treatmentInfo.step,
        treatmentId: dto.treatmentInfo.treatmentInfoUuid,
      },
      period: {
        start: formatLocalToYyyyMmDd(startDate),
        end: formatLocalToYyyyMmDd(endDate),
      },
      activityTime: {
        performed: Math.floor(playedTime / 60),
        recommended: Math.floor(dto.treatmentInfo.recommendedTotalPlayTime / 60),
      },
      stateSummary: {
        state: getTreatmentState(dto.treatmentInfo.state),
        dailyProgress: 0,
      },
      adherence: adherence,
      doctor: dto.treatmentInfo.doctorName,
      isAvailableStopTreatment: isAvailableStopTreatment,
      memo: dto.treatmentInfo.memo,
      // plan 자동 생성 종료 날짜를 위한 Date 값 전달.
      activitiesByProgressDay: TreatmentActivityDetailInfoMapper.toEntity(
        planEndDate,
        dto.activitiesByProgressDay,
        dto.treatmentInfo.startDate
      ),
    };
  }
}
